import { GetAllWorkOrderDataProps, WorkOrderData } from './types';

/**
 * Flattens the status-grouped response from getAllWorkOrders into a single
 * array of WorkOrderData, preserving order of status keys.
 */
export const flattenWorkOrders = (
  grouped: GetAllWorkOrderDataProps | undefined
): WorkOrderData[] => {
  if (!grouped) return [];
  return (Object.values(grouped) as Array<WorkOrderData[] | undefined>)
    .filter((items): items is WorkOrderData[] => Array.isArray(items))
    .flat();
};

/**
 * Removes duplicate WorkOrderData entries by id. Useful after flatten when the
 * same OS may appear in multiple status buckets.
 */
export const dedupeWorkOrdersById = (
  rows: WorkOrderData[]
): WorkOrderData[] => {
  const map = new Map<number, WorkOrderData>();
  rows.forEach((row) => map.set(row.id, row));
  return Array.from(map.values());
};
